module.exports = __webpack_public_path__ + "static/media/chatScreen.03939be3.jpg";